<template>
  <div class="information-reported">
    <div v-movein class="module-content-title">资讯报道</div>
    <div v-movein class="module-content-sub-title">INFORMATION REPORTED</div>
    <div class="item-wrapper">
      <div
        v-for="item in showList"
        :key="item.id"
        v-movein
        class="new-item"
        @click="open(item.url)"
      >
        <div class="image-box">
          <img
            v-lazyload
            class="new-image"
            :data-src="item.image"
            alt="图片"
            srcset=""
          />
          <div class="angle-date">
            {{ item.date[0] }}
            <br />
            {{ item.date[1] }}/{{ item.date[2] }}
          </div>
        </div>
        <div class="new-item-title" v-html="item.title"></div>
        <div class="new-item-description" v-html="item.description"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InformationReported',
  data() {
    return {
      list: []
    }
  },
  computed: {
    showList() {
      return this.list.map((item) => {
        return {
          ...item,
          date: item.date.split('-')
        }
      })
    }
  },
  methods: {
    open(url) {
      window.open(url)
    }
  },
  beforeCreate() {
    const xhr = new XMLHttpRequest()
    const time = new Date().getTime()
    xhr.open('GET', `/json/new.json?t=${time}`)
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        this.list = JSON.parse(xhr.responseText).slice(-3)
        this.list.reverse()
      }
    }
    xhr.send()
  }
}
</script>
<style lang="less" scoped>
.information-reported {
  position: relative;
  margin: 0 auto;
  max-width: 1200px;
  min-height: 572px;
  padding-bottom: 143px;
  padding-top: 176px;
  .module-content-title {
    font-family: SourceHanSansCN;
    font-weight: 600;
    font-size: 48px;
    line-height: 64px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: transparent;
    background: linear-gradient(
      167.78deg,
      #ffffff 68.32%,
      rgba(255, 255, 255, 0.38) 96.13%
    );
    background-clip: text;
    text-shadow: 0px 2px 6px #00000014, 0px 6px 2px #0000000f;
  }
  .module-content-sub-title {
    display: flex;
    font-family: Times;
    font-weight: 500;
    font-size: 12px;
    line-height: 32px;
    letter-spacing: 0%;
    text-transform: uppercase;
    text-align: center;
    color: #ffffff;
    justify-content: center;
    align-items: center;
    &::before,
    &::after {
      display: inline-block;
      content: '';
      width: 14px;
      height: 2px;
      background-color: #f02528;
      vertical-align: middle;
      margin: 0 9px;
    }
  }

  .item-wrapper {
    display: flex;
    display: -ms-flexbox;
    margin-top: 82px;
    width: 100%;
    flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    justify-content: space-between;
    -ms-flex-pack: space-between;
    // align-items: start;

    .new-item {
      position: relative;
      margin-bottom: 20px;
      width: 378px;
      min-height: 420px;
      background-color: #1b1a16;
      transition: all 0.3s;
      flex-shrink: 0;
      -ms-flex-shrink: 0;
      box-shadow: 0px 4px 16px 0px #00000040, 0px 0px 24px 0px #00000029;
      &:hover {
        box-shadow: 0px 0px 24px 0px #e2e2e23d;
      }
      .image-box {
        position: relative;
        height: 246px;
        overflow: hidden;
        .new-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .angle-date {
          position: absolute;
          bottom: 0;
          right: 0;
          padding: 8px 0;
          height: 56px;
          width: 56px;
          color: white;
          font-family: Times;
          font-size: 16px;
          line-height: 20px;
          text-align: center;
          background-color: #d2153d;
        }
      }
      .new-item-title {
        padding: 32px 30px;
        font-family: SourceHanSansCN;
        font-size: 24px;
        font-weight: 700;
        line-height: 34px;
        color: #ffffff;
      }
      .new-item-description {
        padding: 0 30px 32px;
        font-size: 16px;
        line-height: 22px;
        color: #ffffff;
        word-break: break-all;
      }
    }
  }
}
@media screen and (min-width: 1024.02px) and (max-width: 1279px) {
  .information-reported {
    .item-wrapper {
      justify-content: space-around;
    }
  }
}
@media screen and (min-width: 768.02px) and (max-width: 1024px) {
  .information-reported {
    .item-wrapper {
      justify-content: space-around;
      .new-item {
        width: 360px;
      }
    }
  }
}

@media screen and (min-width: 430.02px) and (max-width: 768px) {
  .information-reported {
    .item-wrapper {
      padding: 0 20px;
      justify-content: space-around;
    }
  }
}

@media screen and (max-width: 430px) {
  .information-reported {
    .item-wrapper {
      justify-content: space-around;
      .new-item {
        width: calc(100% - 20px);
        height: auto;
      }
    }
  }
}
</style>
